var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.136,
    height: 20.063,
    viewBox: "0 0 20.136 20.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "community",
    transform: "translate(-3.754 -3.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54348",
    "data-name": "Path 54348",
    d: "M8.007,44.211a.35.35,0,1,0-.613.339,9.839,9.839,0,0,0,17.183,0,.35.35,0,0,0-.613-.339,9.109,9.109,0,0,1-15.956,0Z",
    transform: "translate(-2.163 -25.964)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54349",
    "data-name": "Path 54349",
    d: "M24.952,7.925a.35.35,0,1,0,.533-.455,9.836,9.836,0,0,0-14.881,0,.35.35,0,1,0,.533.455,9.132,9.132,0,0,1,13.816,0Z",
    transform: "translate(-4.223 0)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54350",
    "data-name": "Path 54350",
    d: "M18.661,11.523a.35.35,0,1,0,.418.562,7.015,7.015,0,0,1,8.326,0,.35.35,0,1,0,.418-.563,7.717,7.717,0,0,0-9.161,0Z",
    transform: "translate(-9.42 -3.866)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54351",
    "data-name": "Path 54351",
    d: "M20.662,47.522A7.661,7.661,0,0,0,26.7,44.6a.35.35,0,1,0-.549-.435,7.02,7.02,0,0,1-10.976,0,.35.35,0,1,0-.549.435,7.661,7.661,0,0,0,6.037,2.924Z",
    transform: "translate(-6.841 -25.964)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54352",
    "data-name": "Path 54352",
    d: "M4.2,23.779a1.545,1.545,0,0,0,1.349,2.264h3.9a1.76,1.76,0,0,0,1.751,1.77h5.251a1.752,1.752,0,0,0,1.751-1.77h3.9a1.545,1.545,0,0,0,1.349-2.264,4.045,4.045,0,0,0-2.224-1.9,2.2,2.2,0,1,0-2.687,0,4.036,4.036,0,0,0-2.075,1.656,4.721,4.721,0,0,0-1.176-.571,2.54,2.54,0,1,0-2.925,0,4.72,4.72,0,0,0-1.176.572,4.052,4.052,0,0,0-2.075-1.657,2.2,2.2,0,1,0-2.687,0,4.045,4.045,0,0,0-2.224,1.9Zm14.181-3.634a1.5,1.5,0,1,1,1.5,1.5,1.5,1.5,0,0,1-1.5-1.5Zm1.5,2.2a3.347,3.347,0,0,1,2.953,1.767.84.84,0,0,1-.732,1.232H18.042a4.5,4.5,0,0,0-1.029-1.37,3.351,3.351,0,0,1,2.862-1.628ZM11.983,20.9a1.839,1.839,0,0,1,3.678,0,1.839,1.839,0,0,1-3.678,0Zm5.389,4.663a1.06,1.06,0,0,1-.925,1.555H11.2a1.054,1.054,0,0,1-.925-1.555A4.044,4.044,0,0,1,17.372,25.558ZM6.267,20.145a1.5,1.5,0,1,1,1.5,1.5,1.5,1.5,0,0,1-1.5-1.5Zm1.5,2.2a3.356,3.356,0,0,1,2.868,1.628A4.5,4.5,0,0,0,9.6,25.343H5.547a.84.84,0,0,1-.732-1.232,3.347,3.347,0,0,1,2.947-1.767Z",
    transform: "translate(0 -9.028)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownPeople);
export default __webpack_public_path__ + "static/media/profiledropdown-people.a0991da023f930e61338650f278978e8.svg";
export { ForwardRef as ReactComponent };